/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable react-hooks/exhaustive-deps */


import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, TextField, Autocomplete, Button, Checkbox, Divider, FormHelperText, Tooltip, Stack, IconButton, Alert, Paper, FormControlLabel } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { alpha,styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import HeaderCommon from './ApprovalHierarchyHeaderCommon';
import MasterServices from './ApprovalHierarchyMasterServices';
import Iconify from '../../../components/iconify/Iconify';
import DeletePopup from './ApprovalHierarchyDeletePopUp';
import ApprovalHierarchyPopUpHandle from './ApprovalHierarchyPopUpHandle';
import { useAppStore } from '../../../store/appStore';

// Build validation schema
const buildValidationSchema = (entityData) => {
    const schemaFields = {};

    entityData.forEach((field) => {
        let schema;

        switch (field.DataType) {
            case 'Textbox':
                schema = yup.string();
                break;
            case 'Dropdown':
                schema = field.multiple ? yup.array() : yup.mixed();
                break;
            case 'MultiselectDropdown':
                schema = yup.array();
                break;
            default:
                schema = yup.mixed();
        }

        if (field.Validations) {
            field.Validations.forEach((validation) => {
                if (validation.ValidationType === 'Required') {
                    schema = schema.required(validation.ValidationMessage);
                }
                // Add more validation types as needed
            });
        }

        schemaFields[field.DisplayExpr] = schema;
    });

    return yup.object().shape(schemaFields);
};

const custom = ({ field, selectedValues, searchedValue, setSelectedValues, setRequiredeHoverValue, controllerField, setControllFieldValue, ...paperProps }) => { // NOSONAR
    const { children, ...restPaperProps } = paperProps;
    const filteredOptions = field.DefaultValues?.filter(item =>
        item[field.DisplayExpr].toLowerCase().includes(searchedValue.toLowerCase())
    );
    const isAllFilteredSelected = filteredOptions?.every(option =>
        selectedValues.some(selected => selected[field.ValueExpr] === option[field.ValueExpr])
    );
    const isAllSelected = selectedValues.length > 0 && selectedValues.length === field.DefaultValues.length;
    
    return (<Paper {...restPaperProps}>
        <Box onMouseDown={(e) => e.preventDefault()} sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}>
            <FormControlLabel
                sx={{ fontSize: '13px' }}
                onClick={(e) => {
                    e.preventDefault();
                    let newSelectedValues;

                    if (searchedValue?.length > 0) {
                        // Handle filtered selection
                        if (isAllFilteredSelected) {
                            // Unselect filtered options
                            newSelectedValues = selectedValues.filter(item =>
                                !filteredOptions.some(filtered => filtered[field.ValueExpr] === item[field.ValueExpr])
                            );
                        } else {
                            // Select filtered options
                            newSelectedValues = [
                                ...selectedValues.filter(item =>
                                    !filteredOptions.some(filtered => filtered[field.ValueExpr] === item[field.ValueExpr])
                                ),
                                ...filteredOptions
                            ];
                        }
                    } else {
                        // Select/Unselect All when no filter is applied
                        newSelectedValues = isAllSelected ? [] : field.DefaultValues;
                    }

                    setSelectedValues(newSelectedValues);
                    const newValues = newSelectedValues.map(val => val[field.ValueExpr]);
                    setRequiredeHoverValue(newSelectedValues);
                    controllerField.onChange(newSelectedValues);
                    
                    setControllFieldValue(newValues);
                }}
                label={
                    <span style={{ fontSize: '13px', padding: '0.7em' }}>
                        {searchedValue?.length > 0
                            ? isAllFilteredSelected // NOSONAR
                                ? 'Unselect filtered options'
                                : 'Select filtered options'
                            : isAllSelected // NOSONAR
                                ? 'Unselect All'
                                : 'Select All'
                        }
                    </span>
                }
                control={
                    <Checkbox
                        size='small'
                        id="select-all-checkbox"
                        checked={selectedValues.length > 0 && isAllFilteredSelected}  // Use isAllFilteredSelected here
                    />
                }
            />
        </Box>
        <Divider />
        {children}
    </Paper>)
}

export default function ApprovalHierarchyEdit() {
    const [entityData, setEntityData] = useState([]);
    const [displayError, setDisplayError] = useState(false);
    const [getReturn, setReturn] = useState(false);
    
    
    
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(0);
    const [errorCode, setErrorCode] = useState(null);
    const [Edit, setEdit] = useState(false);
    const [cleared, setCleared] = useState(false);
    const [updatedRow, setUpdatedRow] = useState(0);
    const [openLoading, setOpenLoading] = useState(false);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState(null);
    const [currentPage] = useState(1);
    const [getRequiredeHoverValue, setRequiredeHoverValue] = useState([]);
    const [controllFieldValue, setControllFieldValue] = useState([]);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [formattedRows, setFormattedRows] = useState([]);
    const [alert, setAlert] = useState({ severity: '', message: '', show: false });
    const [searchedValue, setSearchedValue] = useState('');
    const [selectedValues, setSelectedValues] = useState([]);
    
    const { handleSubmit, control, setValue,reset } = useForm({
        resolver: yupResolver(buildValidationSchema(entityData))
    });
    const location = useLocation();
    
    const {
        setIsListChanged,
    } = useAppStore();
    const navigate = useNavigate();
    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    const fetchAddControls = async () => {
        try {
            setOpenLoading(true);
            const res = await MasterServices.GetApprovalHierarchyDetails(location.state.data.id);
            
            setFormattedRows((prev) => {
                // Map over DisplayData to create the array of row objects
                const updatedRows = res.DisplayData.map((displayData, index) => {
                    const correspondingData = res.Data.find(data => data.ProcessStep === displayData.ProcessStep);
                    
                    const generateUserData = () => {
                        const userNames = displayData.UserName.split(",");
                        const userIds = correspondingData.ProcessApproverUserId.split(",");

                        // Map the user data into the desired format
                        const result = userIds.map((userId, index1) => ({
                            ProcessApproverUserId: parseInt(userId.trim(), 10),
                            UserName: userNames[index1].trim()
                        }));

                        return result;
                    };

                    // Get the transformed data
                    const userData = generateUserData();
                    return {
                        id: index + 1, // Assuming ID is 1-based
                        processStep: displayData.ProcessStep,
                        processName: displayData.ProcessName,
                        roleName: displayData.RoleName,
                        userNameArray: userData,
                        userName: displayData.UserName,
                        editDelete: 'Edit/Delete',
                        roleId: correspondingData ? correspondingData.ProcessApproverRoleId : null,
                        approverId: correspondingData ? correspondingData.ProcessApproverUserId : null
                    };
                });

                // Return the new array, replacing the previous rows
                return updatedRows;
            });
            setOpenLoading(false);


            setEntityData(res.Controls);
        } catch (err) {
            console.error('Error fetching add controls: ', err);
        }
    };

    





    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.columnHeader}`]: {
            backgroundColor: 'white',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '13px',
            lineHeight: '40px',  // Keep line height consistent
            paddingLeft: '5px', // Remove left padding
        },

        '& .MuiDataGrid-cell': {
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.3)}`, // Top border for all cells
            fontSize: '13px', // Adjust font size if needed
            padding: '4px 5px', // Adjust padding to remove vertical space
            display: 'flex', // Ensure the content is aligned top
            alignItems: 'flex-start', // Align content at the top
            whiteSpace: 'normal', // Allow text to wrap
            wordWrap: 'break-word', // Ensure long words break and wrap to the next line
            overflow: 'visible',  // Make sure overflow content is visible
            height: 'auto', // Allow the cell height to expand based on content
            '&:hover': {
                backgroundColor: 'white',
            },
        },

        // Remove top border for first row
        '& .MuiDataGrid-row:first-child .MuiDataGrid-cell': {
            borderTop: 'none',  // No top border for the first row
        },

        '& .MuiDataGrid-row:last-child .MuiDataGrid-cell': {
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,  // Bottom border for last row
        },

        '& .MuiDataGrid-row': {
            minHeight: '45px',  // Ensure no extra space vertically for rows
            display: 'flex', // Align rows as flex containers
            alignItems: 'stretch', // Stretch row content to match height
            '&:hover': {
                backgroundColor: 'white',
            },
            padding: '0px 0px'

        },

        '& .MuiDataGrid-columnSeparator': {
            display: 'none',
        },

        '& .MuiDataGrid-menuIcon': {
            display: 'none',
        },


    }));

    // Use the DataGrid component with specific rowHeight and headerHeight
    


    const clickHandler = async (data) => {
        setDisplayError(false);
        const newData = entityData.map(values => {
            if (values.LabelName === "User Name") {
                return {
                    ...values,
                    DefaultValues: ''
                };
            }
            return values;
        });
        setEntityData(() => newData);

        try {
            setOpenLoading(true);

            const res = await MasterServices.getRoleWiseUser(data.ProcessApproverRoleId);
            setReturn(res.length === 0);
            
            if (!Array.isArray(entityData)) {
                throw new Error("entityData is not an array");
            }
            const newData2 = entityData.map(values => {
                if (values.LabelName === "User Name") {
                    return {
                        ...values,
                        DefaultValues: res
                    };
                }
                return values;
            });

            setEntityData(newData2);
            setOpenLoading(false);

        } catch (err) {
            console.error('Error fetching invoice list: ', err);
            setError(err.response.data.error.message);
            setErrorCode(err.response.status);
            setOpen(true);
            setOpenLoading(false);
        }
    };

    const newUpdatedForm = async (data) => { // NOSONAR

        try {




             //  console.log(data, data)
            if (Edit) {
                setFormattedRows((prev) => {
                    // Create a shallow copy of the previous rows
                    const updatedRows = [...prev];

                    // Update the row at the index `updatedRow`
                    updatedRows[updatedRow - 1] = {
                        id: updatedRow,
                        processStep: updatedRow,
                        userNameArray: data?.UserName,
                        processName: data?.ProcessName || "",
                        roleName: selectedDropdownValue?.RoleName || '',
                        userName: data?.UserName !== undefined ? data?.UserName.map((user) => user.UserName).join(', ') : '',
                        editDelete: 'Edit Delete',
                        roleId: data.RoleName,
                        approverId: data.UserName !== undefined ? data.UserName.map((user) => user.ProcessApproverUserId).join(', ') : ''
                    };

                    return updatedRows;
                });
            } else {
                setFormattedRows((prev) => [
                    ...prev,
                    {
                        id: prev.length + 1,
                        processStep: prev.length + 1,
                        userNameArray: data?.UserName,
                        processName: data?.ProcessName || "",
                        roleName: selectedDropdownValue?.RoleName || '',
                        userName: data?.UserName !== undefined ? data?.UserName.map((user) => user.UserName).join(', ') : '',
                        editDelete: 'Edit Delete',
                        roleId: data.RoleName,
                        approverId: data.UserName !== undefined ? data.UserName.map((user) => user.ProcessApproverUserId).join(', ') : ''
                    },
                ]);
            }
        } catch (err) {
            console.error('Error fetching item list: ', err);
            setError(err.response?.data?.error?.message || 'An error occurred');
            setErrorCode(err.response?.status);
            setOpen(true);
            setOpenLoading(false);
        }

        setEdit(false);
    };

    

    useEffect(() => {
        fetchAddControls();
    }, []);

    const onSubmit = async (data) => {
        
        if (data.ProcessApproverRoleId) {
            setOpenLoading(true);
            const newData = entityData.map(values => {
                if (values.LabelName === "User Name") {
                    return {
                        ...values,
                        DefaultValues: ''
                    };
                }
                return values;
            });
            setEntityData(newData);
            clickHandler(data);
        } else {
            if (getReturn) {
                setDisplayError(true);
                return;
            }
            
            newUpdatedForm(data);
            const newData = entityData.map(values => {
                if (values.LabelName === "User Name") {
                    return {
                        ...values,
                        DefaultValues: ''
                    };
                }
                return values;
            });
            setEntityData(newData);
            reset();
        }
    };

    const handleEdit = async (id) => {
        setUpdatedRow(id);
        const rowData = formattedRows.find((row) => row.id === id);
        if (!rowData) return;
        
        try {
            setOpenLoading(true);
            const res = await MasterServices.getRoleWiseUser(rowData.roleId);

            if (!Array.isArray(entityData)) {
                throw new Error('entityData is not an array');
            }

            const rowUpdatedData = entityData.map((values) => {
                if (values.LabelName === 'User Name') {
                    return {
                        ...values,
                        DefaultValues: res,
                    };
                }
                return values;
            });

            setEntityData(rowUpdatedData);
            
            setSelectedDropdownValue({
                "ProcessApproverRoleId": rowData.roleId,
                "RoleName": rowData.roleName
            })























            // Set the form values based on the row data
            setValue('ProcessName', rowData.processName);
            setValue('RoleName', rowData.roleId);
            setValue('UserName', rowData?.userNameArray || []);
            setRequiredeHoverValue(rowData?.userNameArray);
            setSelectedValues(rowData?.userNameArray)
            const userIds = rowData?.userNameArray.map(item => item.ProcessApproverUserId);
            setControllFieldValue(userIds)
            
            setOpenLoading(false);
        } catch (err) {
            console.error('Error fetching invoice list: ', err);
            setError(err.response?.data?.error?.message || 'An error occurred');
            setErrorCode(err.response?.status);
            setOpen(true);
            setOpenLoading(false);
        }

        setEdit(true);
    };

    const saveHandler = async () => {
        if (formattedRows.length === 0) {
            return;
        }
        try {
            setOpenLoading(true);
            const payloadData = formattedRows.map((value) => (
                {
                    "Id": location.state.data.id,
                    "ProcessStep": `${value.processStep}`,
                    "ProcessName": value.processName || '',
                    "ProcessApproverRoleId": `${value.roleId}`,
                    "ProcessApproverUserId": value.approverId
                }
            ))
            
            const res = await MasterServices.UpdateApprovalHierarchy(payloadData);
            if (res) {

                setOpenLoading(false);
                setIsListChanged(true);
                setAlert({ severity: 'success', message: res.Message || 'Operation successful.', show: true });
                setTimeout(async () => {
                    setAlert({ ...alert, show: false });
                    navigate(-1);
                }, 1500);

            } else {
                setOpenLoading(false);
                setError((prev) => res.error?.message ?? prev);
                setErrorCode((prev) => res.error?.code ?? prev)
                setOpen(true)
            }



            setOpenLoading(false);

        } catch (err) {
            console.error('Error fetching invoice list: ', err);
            setError(err.response.data.error.message);
            setErrorCode(err.response.status);
            setOpen(true);
            setOpenLoading(false);
        }
    }
    const deleteHandler = async () => {
        try {
        setOpenLoading(true);
        const res = await MasterServices.DeleteApprovalHierarchy(location.state.data.id);        
        if (res) {
            setOpenLoading(false);
            setIsListChanged(true);
            setAlert({ severity: 'success', message: res.Message || 'Operation successful.', show: true });
            setTimeout(async () => {
                setAlert({ ...alert, show: false });
                navigate(-1);
            }, 1500);
        } else {
            setOpenLoading(false);
            setError((prev) => res.error?.message ?? prev);
            setErrorCode((prev) => res.error?.code ?? prev)
            setOpen(true)
            }
        } catch (err) {
            console.error('Error fetching invoice list: ', err);
            setError(err.response.data.error.message);
            setErrorCode(err.response.status);
            setOpen(true);
            setOpenLoading(false);
        }
    }
    const setHandleDelete = () => {
        setDeleteConfirm(true);

    }
    const handleDelete = (id) => {
        try {
            setFormattedRows((prev) => {
                // Filter out the row with the specified id
                const updatedRows = prev.filter((row) => row.id !== id);

                // Recalculate the processStep for each remaining row
                return updatedRows.map((row, index) => ({
                    ...row,
                    processStep: index + 1, // Reassign processStep based on new index
                    id: index + 1, // Optionally update the id if it should match processStep
                }));
            });

        } catch (err) {
            console.error('Error deleting the row: ', err);
            setError('Failed to delete the row');
            setOpen(true);
        }
    };

    const handleDeleteAllRows = useCallback(() => {
        setShowDeleteConfirmation(true);
    }, []);

    const handleConfirmDeleteAll = useCallback((confirm) => {
        if (confirm) {
            setFormattedRows([]);
        }
        setShowDeleteConfirmation(false);
    }, [setFormattedRows]);

    const columns = [
        { field: 'processStep', headerName: 'Process Step', flex: 0.4, cellClassName: 'processStep' },
        { field: 'processName', headerName: 'Process Name', flex: 0.6, cellClassName: 'processName' },
        { field: 'roleName', headerName: 'Role Name', flex: 1, cellClassName: 'roleName' },
        { field: 'userName', headerName: 'User Name', flex: 1, cellClassName: 'userName' },
        {
            field: 'Edit',
            headerName: 'Edit',
            flex: 0.4,
            align: 'left',
            renderCell: (params) => (
                <Stack direction='row'>
                    <IconButton
                        onClick={() => handleEdit(params.row.id)}
                    >
                        <Iconify icon="material-symbols:edit-outline" width="15px" height="15px" color="primary.main" />
                    </IconButton>
                </Stack>
            ),
        },
        {
            field: 'Delete',
            headerName: 'Delete',
            flex: 0.4,
            align: 'left',
            renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                        onClick={handleDeleteAllRows} title="Delete All"
                        sx={{ display: 'flex', alignItems: 'center', marginLeft: '0px', paddingLeft: 0 }}
                    >
                        <Iconify icon="fluent:delete-32-regular" width='15px' height='15px' color="red" />
                    </IconButton>
                    <span>Delete</span>
                </div>
            ),
            renderCell: (params) => (
                <Stack direction='row'>
                    <IconButton
                        onClick={() => handleDelete(params.row.id)}
                    >
                        <Iconify icon="fluent:delete-32-regular" width='15px' height='15px' color="red" />
                    </IconButton>
                </Stack>
            ),
        },
    ];




    const handleClose = () => {
        setOpen(false);
    };
    function shiftDataToStart(rows1, startIndex1, endIndex1) {
        const selectedRows = rows1.slice(startIndex1, endIndex1);

        const beforeSelected = rows1.slice(0, startIndex1);

        const afterSelected = rows1.slice(endIndex1);
        let returnData;
        if (selectedRows.length % 3 === 0) {

            returnData = selectedRows.concat(beforeSelected, afterSelected);
        } else {

            returnData = selectedRows
        }
        return returnData;

    }
    const startIndex = (currentPage - 1) * 3;
    const endIndex = startIndex + 3;
    const updatedRows = shiftDataToStart(formattedRows, startIndex, endIndex);

    return (
        <Box sx={{ height:'100%' ,display: 'flex', flexDirection:'column',flexGrow:1,}}>
            {open && <ApprovalHierarchyPopUpHandle open={open} handleClose={handleClose} error={error} errorCode={errorCode} />}
            {deleteConfirm && <DeletePopup title="Delete Confirmation" msg='Do you want to delete?' confirm={deleteHandler} setDeleteConfirm={setDeleteConfirm} />}
            {showDeleteConfirmation && (
                <DeletePopup
                    setDeleteConfirm={setShowDeleteConfirmation}
                    confirm={handleConfirmDeleteAll}
                    title="Confirm Deletion"
                    msg="Are you sure you want to delete all rows?"
                />
            )}
            <Box sx={{ minHeight:0, display: 'flex', flexDirection: 'column', flexGrow: 1,  }}>

                <HeaderCommon pageType="Edit" />

                <Box sx={{ minHeight: 0, display: 'flex', flexDirection: 'column', flexGrow: 1, }}>

                    <Box sx={{ overflow: 'auto', flexGrow: 1 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Box
                                rowGap={2}
                                columnGap={2}
                                display='grid'
                                gridTemplateColumns={{
                                    xs: '1fr',
                                    sm: '1fr 1fr',
                                    md: '1fr 1fr 1fr',
                                    lg: '1fr 1fr 1fr',
                                    xl: '1fr 1fr 1fr'
                                }}
                                sx={{ paddingTop: '0.4em' }}
                            >

                                {entityData.map((field) => ( // NOSONAR

                                    <Controller
                                        key={field.ValueExpr}
                                        name={field.DisplayExpr}
                                        control={control}
                                        render={({ field: controllerField, fieldState }) => {

                                            switch (field.DataType) {

                                                case 'Textbox':
                                                    return (
                                                        <div>
                                                            <TextField
                                                                size="small"
                                                                id={field.ValueExpr}
                                                                {...controllerField}
                                                                label={<>
                                                                    {field.LabelName}
                                                                    {field.Validations && field.Validations.length > 0 && field.Validations[0].ValidationType === 'Required' && (
                                                                        <span style={{ color: 'red' }}> *</span>
                                                                    )}
                                                                </>}
                                                                value={controllerField.value || ''}
                                                                onChange={(e) => {
                                                                    controllerField.onChange(e.target.value);
                                                                    
                                                                }}
                                                                fullWidth
                                                                
                                                                InputProps={{
                                                                    style: {
                                                                        fontSize: '13px',  // Set text size to 13px
                                                                    },
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: '14px',  // Adjust label text size to 13px as well
                                                                    },
                                                                }}
                                                            />
                                                            {Boolean(fieldState.error) && (
                                                                <FormHelperText error sx={{color: 'red', fontSize: '10px'}}>
                                                                    {fieldState.error?.message}
                                                                </FormHelperText>
                                                            )}
                                                        </div>
                                                    );

                                                case 'Dropdown':
                                                    return (
                                                        <div>
                                                            <Autocomplete
                                                                options={Array.isArray(field.DefaultValues) ? field.DefaultValues : []}
                                                                size="small"
                                                                getOptionLabel={(option) => option[field.DisplayExpr] || ''}
                                                                multiple={field.multiple || false}
                                                                value={
                                                                    Array.isArray(controllerField.value)
                                                                        ? controllerField.value.map((val) =>
                                                                            (field.DefaultValues || []).find((opt) => opt[field.ValueExpr] === val)
                                                                        )
                                                                        : (field.DefaultValues || []).find((opt) => opt[field.ValueExpr] === controllerField.value) || null
                                                                }
                                                                onChange={(event, newValue, reason) => {
                                                                    if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                                    setValue('UserName', []);
                                                                    setControllFieldValue([]);
                                                                    setSelectedValues([]);
                                                                    setRequiredeHoverValue([]);
                                                                    setSearchedValue('');
                                                                    if (field.DisplayExpr === "RoleName" && newValue === null) {
                                                                        const newData = entityData.map(values => {
                                                                            if (values.LabelName === "User Name") {
                                                                                return {
                                                                                    ...values,
                                                                                    DefaultValues: ''
                                                                                };
                                                                            }
                                                                            return values;
                                                                        });
                                                                        setEntityData(newData);
                                                                    }
                                                                    // Handle value change
                                                                    setSelectedDropdownValue(newValue);

                                                                    if (Array.isArray(newValue)) {
                                                                        const newValues = newValue.map((val) => val[field.ValueExpr]);
                                                                        controllerField.onChange(newValues);
                                                                        
                                                                    } else {
                                                                        controllerField.onChange(newValue ? newValue[field.ValueExpr] : null);
                                                                        

                                                                        // If a value in MultiselectDropdown matches the new Dropdown value, remove it
                                                                       

                                                                        if (newValue?.ProcessApproverRoleId) {
                                                                            onSubmit(newValue);
                                                                        }
                                                                    }
                                                                }
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label={<>
                                                                            {field.LabelName}
                                                                            {field.Validations && field.Validations.length > 0 && field.Validations[0].ValidationType === 'Required' && (
                                                                                <span style={{ color: 'red' }}> *</span>
                                                                            )}
                                                                        </>}
                                                                        fullWidth
                                                                        
                                                                        InputProps={{
                                                                            ...params.InputProps,  // Merge other input props
                                                                            style: {
                                                                                fontSize: '13px',  // Set input text size to 13px
                                                                            },
                                                                        }}
                                                                        InputLabelProps={{
                                                                            style: {
                                                                                fontSize: '14px',  // Set label text size to 13px for consistency
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {Boolean(fieldState.error) && (
                                                                <FormHelperText error style={{ color: 'red', fontSize: '10px' }}>
                                                                    {fieldState.error?.message}
                                                                </FormHelperText>
                                                            )}
                                                        </div>
                                                    );

                                                case 'MultiselectDropdown':
                                                    return (
                                                        <div>

                                                            <Autocomplete
                                                                multiple
                                                                freeSolo
                                                                forcePopupIcon
                                                                size="small"
                                                                options={field.DefaultValues || []}
                                                                getOptionLabel={(option) => option[field.DisplayExpr] || ''}
                                                                disableCloseOnSelect
                                                                value={
                                                                    Array.isArray(controllFieldValue)
                                                                        ? (field.DefaultValues || []).filter((opt) =>
                                                                            controllFieldValue.includes(opt[field.ValueExpr])
                                                                        )
                                                                        : []
                                                                }
                                                                onChange={(event, value, reason) => {
                                                                    if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                                    const newValues = value.map((val) => val[field.ValueExpr]);
                                                                    setControllFieldValue(newValues);
                                                                    setSelectedValues(value);
                                                                    setRequiredeHoverValue(value);
                                                                    controllerField.onChange(value);
                                                                    }
                                                                }}
                                                                slots={{ paper: custom }}
                                                                slotProps={{ paper: { field, selectedValues, searchedValue, setSelectedValues, setRequiredeHoverValue, controllerField, setControllFieldValue } }}
                                                                PaperComponent={custom }

                                                                

                                                                ListboxProps={{
                                                                    style: {
                                                                        maxHeight: '224px',
                                                                        '& .MuiAutocomplete-option': {
                                                                            fontSize: '13px',
                                                                        },
                                                                    },
                                                                }}
                                                                renderOption={(props, option, { selected }) => (                                                             
                                                                     <li {...props} key={option[field?.ValueExpr]}>
                                                                        <Checkbox
                                                                            style={{ marginRight: 8 }}
                                                                            checked={selected}
                                                                            size="small"
                                                                        />
                                                                        {option[field?.DisplayExpr] || 'No Label'}
                                                                    </li>
                                                                )}
                                                                renderTags={(selected) => (
                                                                    <span style={{ fontSize: '13px' }}>
                                                                        {selected.length} items selected
                                                                    </span>
                                                                )}
                                                                renderInput={(params) => (
                                                                    <Tooltip
                                                                        id="tooltip-title-id"
                                                                        title={
                                                                            <div
                                                                                style={{
                                                                                    maxHeight: '150px',
                                                                                    overflowY: controllerField.value?.length > 3 ? 'auto' : 'hidden',
                                                                                }}
                                                                            >
                                                                                <span
                                                                                    style={{
                                                                                        color: '#9e9e9e',
                                                                                        fontSize: '12px',
                                                                                        fontWeight: '300',
                                                                                    }}
                                                                                >
                                                                                    {getRequiredeHoverValue !== undefined ? getRequiredeHoverValue.map(item => item[field.DisplayExpr]).join(', ') : 'No items selected'}
                                                                                </span>
                                                                            </div>
                                                                        }
                                                                        arrow
                                                                        placement="top"
                                                                        PopperProps={{
                                                                            sx: {
                                                                                '& .MuiTooltip-tooltip': {
                                                                                    backgroundColor: 'white',
                                                                                    color: 'black',
                                                                                    border: '1px solid #ccc',
                                                                                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                                                                },
                                                                                '& .MuiTooltip-arrow': {
                                                                                    color: '#f9f9f9',
                                                                                },
                                                                                display: controllerField.value?.length === 0 || controllerField.value === undefined || controllerField.value === null ? 'none' : '',
                                                                            },
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            {...params}
                                                                            size="small"
                                                                            fullWidth
                                                                            sx={{
                                                                                '& .MuiInputBase-input': {
                                                                                    fontSize: '13px',
                                                                                },
                                                                                '& .MuiFormLabel-root': {
                                                                                    fontSize: '14px',
                                                                                },
                                                                            }}
                                                                            onChange={e => setSearchedValue(e.target.value)}
                                                                            label={<>
                                                                                {field.LabelName}
                                                                                {field.Validations && field.Validations.length > 0 && field.Validations[0].ValidationType === 'Required' && (
                                                                                    <span style={{ color: 'red' }}> *</span>
                                                                                )}
                                                                            </>}
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                endAdornment: (
                                                                                    <>
                                                                                        {params.InputProps.endAdornment}
                                                                                        {controllerField?.value?.length > 0 && (
                                                                                            <IconButton
                                                                                                onClick={() => {
                                                                                                    controllerField.onChange([]); // Clear the selected values
                                                                                                    setControllFieldValue([])
                                                                                                    setSelectedValues([])
                                                                                                }}
                                                                                                size="small"
                                                                                                style={{ padding: 0 }}
                                                                                            >
                                                                                                <CloseIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                        )}
                                                                                    </>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                                disableClearable
                                                                fullWidth
                                                            />


                                                            {displayError && (
                                                                <div style={{ marginTop: '10px', marginLeft: '3px', color: 'red', fontSize: '10px' }}>
                                                                    Admin role does not have any users
                                                                </div>
                                                            )}
                                                        </div>
                                                    );

                                                default:
                                                    return null;
                                            }
                                        }}
                                    />
                                ))}

                            </Box>
                            <div style={{ display: 'flex', gap: '20px', margin: '10px 0', justifyContent: "right" }}>
                                <Tooltip title="Add" arrow>
                                    <Button type='submit'

                                        variant='contained'
                                        sx={{
                                            height: '30px',
                                            width: '31px',
                                            bgcolor: '#1badd1',
                                            borderRadius: '4px',
                                            minWidth: 'auto',
                                            fontSize: '25px',
                                            '&:hover': {
                                                bgcolor: '#1badd1',
                                            },
                                        }}

                                    >
                                        +
                                    </Button>
                                </Tooltip>

                            </div>
                        </form>

                        {openLoading && < LoadingProgressBar />}
                        <Divider />
                        <Box sx={{ boxSizing: 'border-box', height: '250px', overflowX: 'auto', }}>
                            <StripedDataGrid  localeText={{ noRowsLabel: '' }}
                                rows={updatedRows}
                                columns={columns}
                                getRowHeight={() => "auto"}
                                headerHeight={35} // Set row height globally 
                                disableSelectionOnClick
                                getRowId={(row) => row.id}                                
                                hideFooter
                                sx={{
                                    height: '100%',
                                    '& .css-1vjh543-MuiDataGrid-footerContainer': {
                                        minHeight: 0
                                    },
                                    '& .css-1t5atbe-MuiDataGrid-root .MuiDataGrid-row': {
                                        paddingBottom: '0px',
                                        height: 'fit-content', // Adjust row height based on content
                                    },
                                    '& .css-1t5atbe-MuiDataGrid-root .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell': {
                                        whiteSpace: 'pre-wrap', // Proper white-space handling for wrapping
                                        lineHeight: 1,
                                        wordWrap: 'break-word',
                                    }
                                }}
                            />
                        </Box>
                    </Box>

                    <Box sx={{py:0.5} }>
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            spacing={1}
                        >
                            <Tooltip title="Save" sx={{ bgcolor: '#43b5a2', color: '#fff', borderRadius: '4px', height: '30px', width: '31px', padding: '4px' }}>
                                <IconButton type="save" onClick={saveHandler}>
                                    <Iconify icon="bx:save" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Delete" sx={{ bgcolor: '#ed5565', color: '#fff', borderRadius: '4px', height: '30px', width: '31px', padding: '4px' }}>
                                <IconButton onClick={setHandleDelete}>
                                    <Iconify icon="fluent:delete-32-regular" />
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    </Box>



                    {alert.show && (
                        <Stack sx={{ width: '30%', height: '2em', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                            <Alert
                                severity={alert.severity}
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => setAlert({ ...alert, show: false })}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                            >
                                {alert.message}
                            </Alert>
                        </Stack>
                    )}
                </Box>

            </Box>
        </Box>
    );
}

 
